import React, { useMemo, forwardRef } from 'react';
import FormGroup from '../FormGroup';
import FormControlMessage from '../FormControlMessage';
import TextInputIcon from './TextInputIcon';
import Tooltip from '../Tooltip';
import Label from '../Label';
import Icon, { ICON_TYPE_SEARCH } from '../Icon';
import { getClassNames } from '../../utils';
import uid from '../../utils/uid';
import CoreInput from './CoreInput';
import './TextInput.css';
import withTheme from '../../hocs/withTheme';

const TextInput = (props: any) => {
    const {
        disabled, error, errorIcon, errorInTooltip, label, isError,
        labelInfobox, helpText, required, questionmark, verified, search = false,
        children, onChange, onKeyUp, onFocus, searchDelay = 300, searchCharsNumber = 3, prefix,
        id, innerRef: ref,
        className, textRight, labelInfo, ...rest
    } = props;
    const iconProps = {
        errorInTooltip, error, errorIcon, questionmark, verified,
    };
    const hasSuffix = useMemo(() => error || questionmark || verified,
        [error, questionmark, verified]);
    const prefixProp = useMemo(() => (search || prefix
        ? { prefix: search ? (
            <>
                {/* @ts-ignore */}
                <Icon type={ICON_TYPE_SEARCH} className="search-icon" />
            </>
            ): prefix }
        : {}), [search, prefix]);

    let searchTimer;
    const onSearch = (e) => {
        const { value } = e.target;

        clearTimeout(searchTimer);
        if (value.length === 0 || value.length >= searchCharsNumber) {
            searchTimer = setTimeout(() => onChange(value), searchDelay);
        } else {
            e.preventDefault();
        }
    };
    const classNames = getClassNames(
        { TextInput_invalid: error || isError },
        { 'TextInput_with-search': search },
        { 'text-right': textRight },
        className,
    );
    const inputId = id || uid('text-input');


    return (
        <FormGroup disabled={disabled} error={error}>
            {label && (
                <Label
                    htmlFor={inputId}
                    label={label}
                    helpText={helpText}
                    labelInfobox={labelInfobox}
                    required={required}
                    labelInfo={labelInfo}
                />
            )}

            <div className='form-field'> 
                <CoreInput
                    {...rest}
                    {...prefixProp}
                    id={inputId}
                    className={classNames}
                    suffix={hasSuffix && (
                        <Tooltip title={errorInTooltip ? error : null}>
                            {/* @ts-ignore */}
                            <TextInputIcon {...iconProps} />
                        </Tooltip>
                    )}
                    disabled={disabled}
                    onChange={search ? onSearch : onChange}
                    onKeyUp={onKeyUp}
                    onFocus={onFocus}
                    ref={ref}
                    search={search}
                />

                {error && !errorInTooltip && (
                    <FormControlMessage>{error}</FormControlMessage>
                )}

                {children && <p>{children}</p>}
            </div>
        </FormGroup>
    );
};

export default forwardRef((props: any, ref) => withTheme(TextInput)({ ...props, innerRef: ref }));
